import { _creditForCaseToCase } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const updateCaseCredit = createAsyncThunk(
  'creditForCaseToCase/update',
  async ({ id, credit, creditValue, creditSymbol, exceptionHospitals }: { id?: string; credit?: number, creditValue?: number, creditSymbol?: string, exceptionHospitals: any }, thunkAPI) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_creditForCaseToCase.update, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ id, credit, creditValue, creditSymbol, exceptionHospitals }),
      });

      if (!response.ok) return thunkAPI.rejectWithValue('Failed to update credit');

      return await response.json();
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
